// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #fff;
}

.not-found h1 {
    margin-bottom: 0;
    text-align: center;
  }

.not-found a {
    display: flex;
    gap: calc(.25rem);
    align-items: center;
    font-weight: 700;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.not-found-legacy {
  margin-top: calc(2rem);
}

.not-found-legacy__thumb {
    width: 9.625rem;
    margin: 1rem auto 1rem;
  }

.not-found-legacy__message1 {
    text-align: center;
    font-size: 1.25rem;
    line-height: 1.875rem;
  }

.not-found-legacy__message2 {
    text-align: center;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

.not-found-legacy__menu {
    width: 7.375rem;
    padding: 0;
    margin: auto auto 1rem;
    list-style: none;
  }

.not-found-legacy__menu__item {
      margin-bottom: calc(.5rem);
    }

@media (width <= 640px) {
    .not-found-legacy__message1 {
      padding: 0 2.1875rem 0 2.1875rem;
    }

    .not-found-legacy__message2 {
      padding: 0 3.75rem 0 3.75rem;
    }
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
